class EvaluationNotesController {
    constructor(evaluationService, pipeDriveService, $mdDialog, $stateParams, $scope, $state, $http) {
        let self = this;
        let evalId = $stateParams.id;
        let pipedriveDealId = null;

        if (evalId) {
            evaluationService.getEvaluationNotes(evalId).then(data => {
                $scope.unreadNotes = data.filter(e => !e.read).length;
            });
        }

        self.showEvaluationNotesPrompt = () => {
            $mdDialog.show({
                clickOutsideToClose: true,
                templateUrl: 'evaluationNotesDialog.tmpl.html',
                parent: angular.element(document.body),
                multiple: true,
                controller: function DialogController($scope, $mdDialog) {
                    let getAllNotes = (evalId) => {
                        $scope.notes = [];

                        evaluationService.getEvaluationNotes(evalId).then((data) => {
                            $scope.notes = data.map(note => {
                                note.createdAt = new Date(note.createdAt);
                                note.editedAt = new Date(note.editedAt);
                                return note;
                            }).sort((a, b) => (a.createdAt < b.createdAt));
                        });

                        evaluationService.getEvaluationData(evalId, $state.includes('mini')).then(evaluation => {
                            pipeDriveService.getNotes(evaluation).then(data => {
                                $scope.notes = ([ ...$scope.notes, ...(data ? data.map(e => Object.assign({}, e, {
                                    value: e.content,
                                    creator: 'Pipedrive Note'
                                })) : []) ]).sort((a, b) => (a.createdAt < b.createdAt));
                                pipedriveDealId = evaluation.pipedriveDealId;
                                $scope.pipedriveDeal = evaluation.pipedriveDealId;
                            });
                        });
                    };
                    $scope.notesQuantity = -3;
                    $scope.visibleNotesQuantity = -3;
                    $scope.closeDialog = function() {
                        evaluationService.markNotesAsRead($scope.notes.filter(e => !e.user_id)).then(() => {
                            $mdDialog.cancel();
                        });
                    };
                    $scope.sendNote = function(result) {
                        if (!$scope.pipedrive) {
                            evaluationService.saveEvaluationNote(evalId, result)
                            .then(() => {
                                $scope.newNote = '';
                                $scope.notesFrom.$setPristine();
                                $scope.notesFrom.$setUntouched();
                            })
                            .then(() => {
                                getAllNotes(evalId);
                            });
                        } else {
                            pipeDriveService.sendNote({
                                content: result,
                                deal_id: pipedriveDealId
                            }).then(() => { getAllNotes(evalId); });
                        }
                    };

                    getAllNotes(evalId);
                }
            }).then(() => {}, () => {
                evaluationService.getEvaluationNotes(evalId).then(data => {
                    $scope.unreadNotes = data.filter(e => !e.read).length;
                });
            });
        };
    };
}

EvaluationNotesController.$inject = ['EvaluationService', 'PipeDriveService', '$mdDialog', '$stateParams', '$scope', '$state', '$http'];

export default EvaluationNotesController;



// WEBPACK FOOTER //
// ./src/app/pages/evaluation/components/notes/evaluationNotesController.js